<script>
import DiaryCard from "@/components/personal_area/DiaryCard.vue";
import { mapGetters } from "vuex";
import PersonalHeader from "../../components/personal_area/PersonalHeader.vue";
import PersonalProfile from "../../components/personal_area/PersonalProfile.vue";
import PersoneInCaption from "../../components/personal_area/PersoneInCaption.vue";

export default {
  components: {
    PersonalHeader,
    PersonalProfile,
    PersoneInCaption,
    DiaryCard
  },
  name: "DiaryPage",
  data(){
    return{
      openFilters: false,
      sort: 'desc',
      page: 1,
      limit: 20,
    }
  },
  computed: {
    ...mapGetters(["notes", "totalNotes", "isFindingAllNote"]),
    showMoreButton() {
      return (this.notes?.length ?? 0) > (this.totalNotes ?? 0)
    }
  },
  methods: {
    goToCreateNote(total) {
      if (total) return;
      this.$router.replace({ name: "notePage" });
    },
    toggleFilters() {
      this.openFilters = !this.openFilters;
    },
    closeFilters() {
      if (!this.openFilters) return;
      this.openFilters = false;
    },
    outsideClick(event) {
      if (!this.openFilters) return;
      if (event.target.closest(".filter-list")) return
      if (event.target.closest("#filter-button")) return
      this.openFilters = false;
    },
    async findAllNotes(page, limit, sort) {
      await this.$store.dispatch("findAllNotes", {
        page,
        limit,
        sort,
      }).then(this.goToCreateNote);
    },
    nextPage() {
      if (this.totalNotes <= this.notes?.length) return
      this.page += 1
    }
  },
  created() {
    this.findAllNotes(this.page, this.limit, this.sort)
  },
  mounted() {
    document.addEventListener("click", this.outsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.outsideClick);
    this.$store.commit("resetNotes");
  },
  watch: {
    sort: {
      handler(sort) {
        this.$store.dispatch("findAllNotes", {
          page: this.page,
          limit: this.limit,
          sort,
        })
          .then(this.goToCreateNote)
          .finally(this.closeFilters);
      },
    },
    page: {
      handler(page) {
        this.$store.dispatch("findAllNotes", {
          page,
          limit: this.limit,
          sort: this.sort,
        }).then(this.goToCreateNote);
      },
    },
    limit: {
      handler(limit) {
        this.$store.dispatch("findAllNotes", {
          page: this.page,
          limit,
          sort: this.sort,
        }).then(this.goToCreateNote);
      },
    }
  }
};
</script>

<template>
  <div class="body">
    <PersonalHeader />
    <main class="main">
      <div class="caption flex al-cent">
        <div class="caption-greetings">
          <h1 class="caption-greetings__title">МОИ ЗАМЕТКИ</h1>
        </div>
        <PersoneInCaption />
      </div>
      <div class="head">
        <RouterLink :to="{ name: 'notePage' }" class="add-note desk">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 52.5C14.49 52.5 3.5 41.51 3.5 28C3.5 14.49 14.49 3.5 28 3.5C41.51 3.5 52.5 14.49 52.5 28C52.5 41.51 41.51 52.5 28 52.5ZM28 7C16.415 7 7 16.415 7 28C7 39.585 16.415 49 28 49C39.585 49 49 39.585 49 28C49 16.415 39.585 7 28 7Z" fill="#fafafa" />
            <path d="M28 40.25C27.02 40.25 26.25 39.48 26.25 38.5V17.5C26.25 16.52 27.02 15.75 28 15.75C28.98 15.75 29.75 16.52 29.75 17.5V38.5C29.75 39.48 28.98 40.25 28 40.25Z" fill="#fafafa" />
            <path d="M38.5 29.75H17.5C16.52 29.75 15.75 28.98 15.75 28C15.75 27.02 16.52 26.25 17.5 26.25H38.5C39.48 26.25 40.25 27.02 40.25 28C40.25 28.98 39.48 29.75 38.5 29.75Z" fill="#fafafa" />
          </svg>
          Добавить заметку
        </RouterLink>
        <div class="filter">
          <button id="filter-button" class="filter-content" @click="toggleFilters">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.33334 24C4.95556 24 4.63912 23.872 4.384 23.616C4.12889 23.36 4.00089 23.0436 4 22.6667C3.99912 22.2898 4.12712 21.9733 4.384 21.7173C4.64089 21.4613 4.95734 21.3333 5.33334 21.3333H10.6667C11.0444 21.3333 11.3613 21.4613 11.6173 21.7173C11.8733 21.9733 12.0009 22.2898 12 22.6667C11.9991 23.0436 11.8711 23.3604 11.616 23.6173C11.3609 23.8742 11.0444 24.0018 10.6667 24H5.33334ZM5.33334 17.3333C4.95556 17.3333 4.63912 17.2053 4.384 16.9493C4.12889 16.6933 4.00089 16.3769 4 16C3.99912 15.6231 4.12712 15.3067 4.384 15.0507C4.64089 14.7947 4.95734 14.6667 5.33334 14.6667H18.6667C19.0444 14.6667 19.3613 14.7947 19.6173 15.0507C19.8733 15.3067 20.0009 15.6231 20 16C19.9991 16.3769 19.8711 16.6938 19.616 16.9507C19.3609 17.2076 19.0444 17.3351 18.6667 17.3333H5.33334ZM5.33334 10.6667C4.95556 10.6667 4.63912 10.5387 4.384 10.2827C4.12889 10.0267 4.00089 9.71022 4 9.33333C3.99912 8.95644 4.12712 8.64 4.384 8.384C4.64089 8.128 4.95734 8 5.33334 8H26.6667C27.0444 8 27.3613 8.128 27.6173 8.384C27.8733 8.64 28.0009 8.95644 28 9.33333C27.9991 9.71022 27.8711 10.0271 27.616 10.284C27.3609 10.5409 27.0444 10.6684 26.6667 10.6667H5.33334Z" fill="#100C40" />
            </svg>
            Ваши заметки
          </button>
          <div class="filter-list" :class="{'filter-list--open': openFilters}">
            <label class="filter-element flex al-cen ">
              <span class="check">
                  <input type="radio"
                      class="check__input" value="desc"
                      v-model="sort" name="sort">
                  <svg class="check__box "  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2019_7946)">
                      <path d="M12 0.5H4C2.067 0.5 0.5 2.067 0.5 4V12C0.5 13.933 2.067 15.5 4 15.5H12C13.933 15.5 15.5 13.933 15.5 12V4C15.5 2.067 13.933 0.5 12 0.5Z" fill="#FAFAFA" />
                    </g>
                    <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="#CBCAD5" />
                    <defs>
                      <clipPath id="clip0_2019_7946">
                        <rect width="16" height="16" rx="2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="check__box-on" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2019_7946)">
                      <path d="M12 0.5H4C2.067 0.5 0.5 2.067 0.5 4V12C0.5 13.933 2.067 15.5 4 15.5H12C13.933 15.5 15.5 13.933 15.5 12V4C15.5 2.067 13.933 0.5 12 0.5Z" fill="#FAFAFA" />
                      <path d="M6.08703 9.65704L4.01589 7.72532C3.90429 7.62123 3.75292 7.56276 3.59509 7.56276C3.43726 7.56276 3.2859 7.62123 3.1743 7.72532C3.0627 7.8294 3 7.97057 3 8.11778C3 8.19066 3.01539 8.26284 3.04529 8.33017C3.07521 8.39751 3.11904 8.4587 3.1743 8.51024L5.66923 10.8372C5.90201 11.0543 6.27804 11.0543 6.51082 10.8372L12.8257 4.94748C12.9373 4.8434 13 4.70223 13 4.55502C13 4.40782 12.9373 4.26665 12.8257 4.16256C12.7141 4.05848 12.5627 4 12.4049 4C12.2471 4 12.0957 4.05848 11.9841 4.16256L6.08703 9.65704Z" fill="#FF2031" />
                    </g>
                    <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="#CBCAD5" />
                    <defs>
                      <clipPath id="clip0_2019_7946">
                        <rect width="16" height="16" rx="2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
              </span>
              <span class="check-text">От новых к старым
              </span>
            </label>
            <label class="filter-element flex al-cen ">
              <span class="check">
                  <input type="radio"
                      class="check__input" value="asc"
                      v-model="sort"
                      name="sort"
                      >
                  <svg class="check__box "  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2019_7946)">
                      <path d="M12 0.5H4C2.067 0.5 0.5 2.067 0.5 4V12C0.5 13.933 2.067 15.5 4 15.5H12C13.933 15.5 15.5 13.933 15.5 12V4C15.5 2.067 13.933 0.5 12 0.5Z" fill="#FAFAFA" />
                    </g>
                    <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="#CBCAD5" />
                    <defs>
                      <clipPath id="clip0_2019_7946">
                        <rect width="16" height="16" rx="2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="check__box-on" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2019_7946)">
                      <path d="M12 0.5H4C2.067 0.5 0.5 2.067 0.5 4V12C0.5 13.933 2.067 15.5 4 15.5H12C13.933 15.5 15.5 13.933 15.5 12V4C15.5 2.067 13.933 0.5 12 0.5Z" fill="#FAFAFA" />
                      <path d="M6.08703 9.65704L4.01589 7.72532C3.90429 7.62123 3.75292 7.56276 3.59509 7.56276C3.43726 7.56276 3.2859 7.62123 3.1743 7.72532C3.0627 7.8294 3 7.97057 3 8.11778C3 8.19066 3.01539 8.26284 3.04529 8.33017C3.07521 8.39751 3.11904 8.4587 3.1743 8.51024L5.66923 10.8372C5.90201 11.0543 6.27804 11.0543 6.51082 10.8372L12.8257 4.94748C12.9373 4.8434 13 4.70223 13 4.55502C13 4.40782 12.9373 4.26665 12.8257 4.16256C12.7141 4.05848 12.5627 4 12.4049 4C12.2471 4 12.0957 4.05848 11.9841 4.16256L6.08703 9.65704Z" fill="#FF2031" />
                    </g>
                    <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" stroke="#CBCAD5" />
                    <defs>
                      <clipPath id="clip0_2019_7946">
                        <rect width="16" height="16" rx="2" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
              </span>
              <span class="check-text">От старых к новым
              </span>
            </label>
          </div>
        </div>

      </div>
      <div class="filling ">
        <div v-if="notes?.length" class="diary-group">
          <DiaryCard v-for="note in notes" :key="note.id" v-bind="note" />
        </div>
        <button v-if="showMoreButton" :disabled="isFindingAllNote" class="button" @click="nextPage">Еще</button>
      </div>
        <RouterLink :to="{ name: 'notePage' }" class="add-note mob">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 52.5C14.49 52.5 3.5 41.51 3.5 28C3.5 14.49 14.49 3.5 28 3.5C41.51 3.5 52.5 14.49 52.5 28C52.5 41.51 41.51 52.5 28 52.5ZM28 7C16.415 7 7 16.415 7 28C7 39.585 16.415 49 28 49C39.585 49 49 39.585 49 28C49 16.415 39.585 7 28 7Z" fill="#fafafa" />
            <path d="M28 40.25C27.02 40.25 26.25 39.48 26.25 38.5V17.5C26.25 16.52 27.02 15.75 28 15.75C28.98 15.75 29.75 16.52 29.75 17.5V38.5C29.75 39.48 28.98 40.25 28 40.25Z" fill="#fafafa" />
            <path d="M38.5 29.75H17.5C16.52 29.75 15.75 28.98 15.75 28C15.75 27.02 16.52 26.25 17.5 26.25H38.5C39.48 26.25 40.25 27.02 40.25 28C40.25 28.98 39.48 29.75 38.5 29.75Z" fill="#fafafa" />
          </svg>
          Добавить заметку
        </RouterLink>
    </main>
    <PersonalProfile />
  </div>
</template>

<style scoped>
.body {
  display: flex;
}

.main {
  margin: 0 60px 56px 40px;
  width: 100%;
}

.content-element-caption__title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
}

.content-element-caption__more {
  font-size: 14px;
  line-height: 1;
  position: relative;
  padding-right: 20px;
  color: rgba(16, 12, 64, 0.699999988079071);
}

.content-element-caption__more::after {
  position: absolute;
  background: url(../../assets/img/list.svg);
  content: "";
  display: block;
  right: 0;
  top: -2px;
  width: 16px;
  height: 16px;
}

/* Caption */

.caption {
  padding: 40px 0px 0px 0px;
}

.caption-greetings__title {
  font-family: "PT";
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
}

/* filling */
.filling {
  max-width: 100%;
  width: 100%;
  align-items: flex-start;
}

.content-element {
  max-width: 100%;
  width: 100%;
}



/*content*/
.content {
  padding: 20px 0px 0px 0px;
  width: 100%;
}
.check {
  display: flex;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.check:hover {
  opacity: 0.8;
}

.check__input {
  position: absolute;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.check__input:checked ~ .check__box {
  display: none;
}

.check__input:checked ~ .check__box-on {
  display: flex;
}

.check__box {
  width: 100%;
  height: 100%;
}

.check__box-on {
  display: none;
}
.filter-element{
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.check-text{
  font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #100c40;
}
.head{
  margin-top: 17px;
}
.add-note{
  display: flex;
  gap: 24px;
  padding: 24px;
  max-width: 536px;
  width: 100%;
  font-weight: 400;
  font-size: 36px;
  line-height: 120%;
  color: #fff;
  border-radius: 10px;
  background: #ff2031;
  align-items: center;
}

.filter{
  margin-top: 32px;
  position: relative;
}
.filter-content{
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 100%;
  color: #100c40;

}

.filter-list{
  margin-top: 5px;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 40px 30px 0 rgba(0, 0, 0, 0.06);
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: unset;
  position: absolute;
  left: -16px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
  transition: transform 0.5s ease-in-out;
}
.filter-list--open{
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
  z-index: 10;
}
.filling{
  margin-top: 19px;
}
.diary-group{
 display: grid;
grid-template-columns: repeat(auto-fill, minmax(220px, 260px));
  gap: 24px;
}


@media (max-width: 1300px) {
  .main {
    margin-left: 20px;
  }

  /* Caption */
  .caption {
    padding: 40px 0px 30px 0px;
    justify-content: space-between;
  }

  .caption-greetings__title {
    font-size: 24px;
  }

}

@media (max-width: 950px) {
  .body {
    flex-direction: column;
  }

  .filling {
    flex-direction: column;
  }

  .caption {
    padding: 40px 0 0 0;
  }

  .caption-greetings {
    margin: 0 auto;
  }

  .caption-greetings__title {
    font-size: 32px;
  }

  .main {
    margin-left: 0;
    margin-right: 0;
    padding: 0 20px;
  }

  .profile {
    display: none;
  }

  /* additionall */
  .my-course-group {
    overflow-x: scroll;
  }

  .additionally-element {
    text-align: center;
  }

  .additionally {
    max-width: 100%;
  }

  .my-course-group {
    margin-top: 20px;
    flex-direction: row;
    overflow-x: visible;
    padding: 10px;
    position: relative;
  }

  .slider-last-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    left: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .my-course-group-wrapper {
    flex-direction: row;
    overflow-x: scroll;
  }

  .slider-next-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    right: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .slider-next-block img {
    width: 24px;
    height: 24px;
  }

  .slider-last-block img {
    width: 24px;
    height: 24px;
  }

  .separate-curse {
    max-width: 280px;
  }

  .filling-element {
    margin-bottom: 40px;
    margin-right: 0;
  }

  .content-filling {
    grid-template-columns: repeat(2, 1fr);
  }

  .slider-filling-element {
    margin: 0 auto 20px auto;
  }
  .add-note{
    margin-top: 24px;
    padding: 16px;
        gap: 16px;
    font-size: 16px;
    width: unset;
    justify-content: center;
    height: 66px;
  }
  .add-note svg{
    display: none;
  }
  .head{
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .main {
    padding: 0 10px;
  }

  .carousel {
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 20px 20px 45px 20px;
  }

  .carousel * {
    margin: 0 auto;
  }

  .carousel-title {
    max-width: 267px;
    font-size: 32px;
  }

  .carousel-text {
    margin-top: 10px;
    max-width: 267px;
    font-size: 12px;
  }

  .carousel-button {
    margin-top: 199px;
    max-width: 223px;
  }

  .carousel-img {
    width: 298px;
    height: 282px;
    right: calc(50% - 149px);
  }

  .content {
    padding: 0 0 00px 0;
  }

  /*category*/
  .category-element {
    padding: 0;
    margin-top: 20px;
  }

  .category-element__caption {
    margin-bottom: 0;
  }

  /* description */
  .description {
    margin-top: 20px;
  }

  .description-nav {
    position: relative;
  }

  .description-nav-selected {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: #ffffff;
    border: 1px solid rgba(16, 12, 64, 0.2);
    border-radius: 10px;
    justify-content: space-between;
    width: 100%;
    box-shadow: 0px 40px 140px rgba(0, 0, 0, 0.06);
  }

  .description-nav-selected__text {
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav-filling {
    display: none;
    background: #fff;
    max-width: 100%;
    width: 100%;
    flex-direction: column;
    position: absolute;
    z-index: 2;
  }

  .description-nav__element {
    width: 100%;
    text-align: left;
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element-chozen {
    background: #fff;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element:not(:last-child) {
    border-bottom: 1px solid rgba(16, 12, 64, 0.4);
    border-radius: 0 0 0 0;
  }

  .description-nav__element:first-child {
    border-radius: 10px 10px 0 0;
  }

  /*popular-course*/
  .content-element-caption__title {
    font-size: 20px;
    margin: 0 auto;
  }

  .content-element-caption__more {
    display: none;
  }

  .popular-course-filling {
    padding: 20px 0;
  }

  .tags {
    flex-wrap: nowrap;
    overflow-x: scroll;
    margin-top: 50px;
  }

  .content-filling {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 20px 0 0 0;
  }
  .diary-group{
    display: flex;
    flex-direction: column;
  }
  .filter{
    margin-top: 0;
  }
  .head{
    margin-top: 30px;
  }
}

.button{
  margin-top: 50px;
  margin-inline: auto;
  width: 100px;
  background: #ff2031;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
}
.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.desk{
}
.mob{
  display: none;
}
@media (max-width:600px ) {
  .desk{
  display: none;
  }
  .mob{
    display: flex;
  }
}
</style>
